<div class="modal fade" id="share-modal" role="dialog" tabindex="-1" aria-hidden="true" aria-labelledby="share-modal" [ngStyle]="{'display': (showShareModal || showInviteModal || showShareLinkModal) && !universalService.isMobileDevice ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content h-90">
      <div class="modal-header">
        <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
          <span class="NeueFile_Cancel"></span>
          <span class="esc">esc</span>
        </button>
        @if (showShareModal) {
          <h5>Share</h5>
        }
        @if (showInviteModal) {
          <h5>Invite</h5>
        }
        @if (showShareLinkModal) {
          <h5>Share Link</h5>
        }
      </div>

      <div class="modal-body border-bottom-0">
        <div class="shareLinkContent">
          <div class="row m-0 p-0">
            <div class="col-md-3 m-0 p-0">
              <input type="text" class="ToTag" value="Share via email:" readonly>
            </div>

            @if (showShareModal || showInviteModal) {
              <div class="col-md-9 m-0 p-0 receipientsList">
                <tag-input theme='minimal' [(ngModel)]='implRef.receiverIds' (onRemove)="onItemRemoved($event)" (onAdd)="onItemAdded($event)" [separatorKeyCodes]="[32,188,13,9]" [placeholder]="''" [secondaryPlaceholder]="'Add Email ID'" [blinkIfDupe]="true" [addOnPaste]="true"
                  [pasteSplitPattern]="implRef.splitPattern" [editable]="true" (onTagEdited)="onTagEdited($event)" [modelAsStrings]="true" (onSelect)="SelectedTagForEditing($event)" [onlyFromAutocomplete]="false">
                  <tag-input-dropdown [showDropdownIfEmpty]="false" [dynamicUpdate]="false" [autocompleteItems]="emailList" zIndex="10000">
                  </tag-input-dropdown>
                </tag-input>
                <!-- <tag-input #rid id="rEmail" theme='minimal' class="ngxChips inpt-email" [(ngModel)]='implRef.receiverIds' (onRemove)="onItemRemoved($event)" [modelAsStrings]="true" (onAdd)="onItemAdded()" (onTextChange)="onTextChange($event)" (onFocus)="startLabelAnimation($event)"
                (onBlur)="stopLabelAnimatio($event)" (onTagEdited)="onTagEdited($event)" [separatorKeyCodes]="[32,188,13]" [placeholder]="''" [secondaryPlaceholder]="''" [clearOnBlur]="false" [addOnBlur]="true" [blinkIfDupe]="true" [allowDupes]="false"
                [addOnPaste]="true" [editable]="true" [pasteSplitPattern]="implRef.splitPattern" [maxItems]="implRef.emailLimit" (onSelect)="SelectedTagForEditing($event)">
              </tag-input> -->
            </div>
          }

          <!-- For Create share link, need to add limit maxItem-->
          @if (showShareLinkModal) {
            <div class="col-md-9 m-0 p-0 receipientsList">
              <tag-input theme='minimal' [(ngModel)]='implRef.receiverIds' (onRemove)="onItemRemoved($event)" (onAdd)="onItemAdded($event)" [separatorKeyCodes]="[32,188,13,9]" [placeholder]="''" [secondaryPlaceholder]="'Add Email ID'" [blinkIfDupe]="true" [addOnPaste]="true"
                [pasteSplitPattern]="implRef.splitPattern" [editable]="true" (onTagEdited)="onTagEdited($event)" [modelAsStrings]="true" (onSelect)="SelectedTagForEditing($event)" [maxItems]="20" [onlyFromAutocomplete]="false">
                <tag-input-dropdown [showDropdownIfEmpty]="false" [dynamicUpdate]="false" [autocompleteItems]="emailList" zIndex="10000">
                </tag-input-dropdown>
              </tag-input>
            </div>
          }
        </div>
        <div class="inputError mt-2">
          @if (implRef.mailError.error!='') {
            <span><i class="NeueAlert mr-1"></i> {{implRef.mailError.error}}</span>
          }
        </div>
      </div>
      <div class="input-note">
        <p>Note: To include one or multiple email IDs, press the space, comma, or {{this.universalService.browserDetails.os.name == "macOS" ? 'return':'enter'}} key.</p>
      </div>
      @if (implRef.mailError.error=='' && implRef.receiverIds.length > 0 && showShareModal) {
        <div class="commentBox">
          <textarea style="resize:none" maxlength="200" #comments placeholder="Add a comment here" class="mt-2 ml-1 p-2" (keyup)="validateComments($event,comments.value)" [(ngModel)]="implRef.commentMessage"></textarea>
          <div class="inputError mt-2">
            @if (implRef.commentAlert!='') {
              <span><i class="NeueAlert mr-1"></i> {{implRef.commentAlert}}</span>
            }
          </div>
        </div>
      }

      @if (implRef.mailError.error!='' || implRef.receiverIds.length==0 || showInviteModal) {
        <div class="row sharingOptions mt-5">
          <div class="col-md-4 col-xs-4 center-align">
            <button tabindex="-1" class="NeueCopy copyButton" (click)="copyLink('Copy')"></button>
            <div class="row optionName">
              <span>{{copyText}}</span>
            </div>
          </div>
          <!-- <div class="col-md-3 col-xs-3 center-align">
            <button tabindex="-1" class="NeueFacebook shareOnFacebook" (click)="copyLink('Fb')"></button>
            <div class="row optionName">
              <span>Facebook</span>
            </div>
          </div> -->
          <div class="col-md-4 col-xs-4 center-align">
            <!-- <button class="Neuewhatsapp shareOnWhatsApp ml-3" (click)="copyLink('WhatsApp')"></button> -->
                        <a tabindex="-1" [href]="'https://wa.me/?text=' + this.socialSahreLink" target="_blank" rel="noopener noreferrer">
                            <button class="Neuewhatsapp shareOnWhatsApp"></button>
                        </a>
                        <div class="row optionName ">
                            <span>WhatsApp</span>
                        </div>
                        <!-- <span>WhatsApp</span> -->
                    </div>
                    <div class="col-md-4 col-xs-4 center-align">
                        <a tabindex="-1" [href]="'https://twitter.com/intent/tweet?text=' + this.socialSahreLink" target="_blank" rel="noopener noreferrer">
                            <button class="Neuetwitter shareOnTwitter"></button>
                        </a>
                        <div class="row optionName">
                            <span>Twitter</span>
                        </div>
                        <!-- <span>Twitter</span> -->
                    </div>
                </div>
}
            </div>
            <div class="modal-footer border-top-0 p-3">
                {{implRef.receiverIds.length}}
                <div class="share-btn-main">
                    <button type="submit" [disabled]=" implRef.mailError.error!='' || implRef.receiverIds.length==0" class="pointer" (click)="sendShareLinkToSelectedRecipients()">{{buttonText}}</button>
                </div>
                <!-- <div class="max-min-pop-up">
                    @if (!maximize) {
<span class="NeueFullScreen mr-3" title="Maximize" (click)="transformModal()"></span>
}
                    @if (maximize) {
<span class="NeueExitFullScreen mr-3" title="Minimize" (click)="transformModal()"></span>
}
                </div> -->
            </div>

        </div>
    </div>
</div>